<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 v-if="organizationUnitId" :tid="organizationUnitId"></AdminNavigationV2>
        </div>

        <div v-if="isAccepted">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user</h1>

                        <div v-if="!isDeleted">
                            <a :href="`/#/admin/organizations/users/manage/details/${id}`" class="btn btn-link btn-sm">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                <span>Edit</span>
                            </a>

                            <button v-if="isLocked" @click="handleUnlockUserCommandV1" class="btn btn-link btn-sm">
                                <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                                <span>Unlock</span>
                            </button>
                            <button v-else @click="handleLockUserCommandV1" class="btn btn-link btn-sm">
                                <i class="fa fa-lock" aria-hidden="true"></i>
                                <span>Lock</span>
                            </button>

                            <div class="dropdown d-inline">
                                <button class="btn btn-link" type="button" data-toggle="dropdown" aria-expanded="false">
                                    <i class="fa fa-key" aria-hidden="true"></i>
                                    <span>Reset password</span>
                                </button>
                                <div class="dropdown-menu p-3 shadow-sm" style="width: 400px;">
                                    <button @click="handleResetPasswordCommandV1" class="btn btn-secondary">
                                        <i class="fa fa-key" aria-hidden="true"></i>
                                        <span>Reset password</span>
                                    </button>
                                    <br /><br />
                                    <div class="form-group form-check">
                                        <input v-model="sendPasswordToEmailEnabled" type="checkbox" class="form-check-input" id="sendPasswordOnEmail">
                                        <label class="form-check-label" for="sendPasswordOnEmail">Send password on additional email</label>
                                    </div>
                                    <input v-model="sendPasswordToEmail" type="email" class="form-control" placeholder="Email" v-show="sendPasswordToEmailEnabled">
                                </div>
                            </div>

                            <button @click="handleSignoutFromAllSessionsCommandV1" class="btn btn-link btn-sm">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                                <span>Revoke sessions</span>
                            </button>

                            <button @click="handleDisableUserCommandV1" class="btn btn-link btn-sm">
                                <i class="fa fa-remove" aria-hidden="true"></i>
                                <span>Delete</span>
                            </button>
                        </div>

                        <div v-else>
                            <button @click="handleEnableUserCommandV1" class="btn btn-link btn-sm">
                                <i class="fa fa-undo" aria-hidden="true"></i>
                                <span>Restore user</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <hr style="border-color: #bbb; margin: 20px 0 30px;" />

            <div class="container">
                <div v-if="!isDeleted">
                    <h3>{{displayName}}</h3>
                    <h6>{{email}}</h6>
                    <h6>{{userType}}</h6>
                    <a :href="`/#/admin/organizations/users/manage/roles/${id}`" class="btn btn-secondary btn-sm">
                        Manage roles
                    </a>
                </div>
                <div v-else>
                    <h3 class="fg-color-red">{{displayName}} is deleted</h3>
                    <h6>{{email}}</h6>
                </div>
                <br />

                <div v-if="!isDeleted">
                    <h4>Workspaces</h4>
                    <h6 v-for="w in workspaces">{{w.Name}}</h6>
                    <h6 v-if="workspaces.length==0">No workspaces assigned</h6>
                    <a :href="`/#/admin/organizations/users/manage/workspaces/${id}`" class="btn btn-secondary btn-sm">
                        Manage workspaces
                    </a>
                </div>
            </div>
        </div>

        <div v-else-if="isRequested">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user access request</h1>
                    </div>
                </div>
            </div>

            <hr style="border-color: #bbb; margin: 20px 0 30px;" />

            <div class="container">
                <h3>{{displayName}}</h3>
                <h6 v-if="displayName != email">{{email}}</h6>
                <h6 v-if="requestedBy">Requested by {{requestedBy}}</h6>
                <button @click="handleAcceptUserAccessRequestCommandV1" class="btn btn-lg btn-success">Accept</button>
                <button @click="handleRejectUserAccessRequestCommandV1" class="btn btn-lg btn-danger">Reject</button>
            </div>
        </div>

        <div v-else-if="isRejected">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user access request</h1>
                    </div>
                </div>
            </div>

            <hr style="border-color: #bbb; margin: 20px 0 30px;" />

            <div class="container">
                <h3 class="text-danger">Rejected user access for {{displayName}}</h3>
                <h6 v-if="displayName != email">{{email}}</h6>
                <h6 v-if="requestedBy">Requested by {{requestedBy}}</h6>
                <button @click="handleAcceptUserAccessRequestCommandV1" class="btn btn-lg btn-success">Accept</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import Queries from "@Organizations/Users/Domain/queries-vue-component";
    import Commands from "@Organizations/Users/Domain/commands-vue-component";
    import { AcceptUserAccessRequestCommandV1, RejectUserAccessRequestCommandV1 } from "@Organizations/Users/Domain/commands-core";
    import WorkspacesQueries from "@Organizations/Workspaces/Domain/queries-vue-component";
    import "@common/AdminNavigationV2.vue";

    @Component({
        watch: {
            sendPasswordToEmailEnabled: 'sendPasswordToEmailEnabledChanged'
        }
    })
    export default class ManageUserPage extends mixins(PageBase, Queries, WorkspacesQueries, Commands) {
        mounted() {
            this.setTitle("Manage user");
            this.runCurrentUserQueryV1(false, true, false);
            this.runUserQueryV1(this.id);
            this.runWorkspacesByUserQueryV1(this.id);
        }

        sendPasswordToEmailEnabled: boolean = false;
        sendPasswordToEmail: string = null;

        get userSessionDetails() { return this.model?.UserSessionDetails; }
        get userWithSensitiveData() { return this.model?.UserWithSensitiveData; }
        get userWorkspacesList() { return this.model?.UserWorkspaces; }

        get currentEmail() { return this.userSessionDetails?.Email; }

        get user() { return this.userWithSensitiveData; }
        get email() { return this.user?.Email; }
        get displayName() { return this.user?.DisplayName; }
        get userType() { return this.user?.IsGlobalAdmin ? 'Global Admin' : 'User'; }
        get isLocked() { return this.user?.IsLocked; }
        get isDeleted() { return this.user?.IsDeleted; }
        get isRequested() { return this.user?.IsRequested; }
        get isAccepted() { return this.user?.IsAccepted; }
        get isRejected() { return this.user?.IsRejected; }
        get requestedBy() { return this.user?.RequestedBy; }
        get organizationUnitName() { return this.user?.OrganizationUnitName; }
        get organizationUnitId() { return this.user?.OrganizationUnitId; }

        get workspaces() { return this.userWorkspacesList?.Workspaces || []; }

        succeedAnyCommand(status) {
            if (AcceptUserAccessRequestCommandV1.matchType(status.Command)) {
                this.navigateTo(`/#/admin/organizations/users/requests/${this.organizationUnitId}`)
            }
            else if (RejectUserAccessRequestCommandV1.matchType(status.Command)) {
                this.navigateTo(`/#/admin/organizations/users/requests/${this.organizationUnitId}`)
            }
            else {
                this.runUserQueryV1(this.id);
            }
        }

        //@Watch('sendPasswordToEmailEnabled')
        sendPasswordToEmailEnabledChanged(sendPasswordToEmailEnabled) {
            if (!sendPasswordToEmailEnabled) {
                this.sendPasswordToEmail = null;
            }
        }

        handleLockUserCommandV1() {
            if (confirm(`Do you really want to lock user ${this.email}?`))
                this.invokeLockUserCommandV1(this.id, "Locked by admin", null);
        }

        failedLockUserCommandV1(status) {
            alert(status.Error)
        }

        handleUnlockUserCommandV1() {
            if (confirm(`Do you really want to unlock user ${this.email}?`))
                this.invokeUnlockUserCommandV1(this.id);
        }

        handleResetPasswordCommandV1() {
            if (confirm(`Do you really want to reset password for user ${this.email}?`))
                this.invokeResetPasswordCommandV1(this.id, this.sendPasswordToEmailEnabled ? this.sendPasswordToEmail : null);
        }

        handleSignoutFromAllSessionsCommandV1() {
            if (confirm(`Do you really want to revoke all sessions for user ${this.email}?`))
                this.invokeSignoutFromAllSessionsCommandV1(this.id);
        }

        handleDisableUserCommandV1() {
            if (confirm(`Do you really want to delete user ${this.email}?`))
                this.invokeDisableUserCommandV1(this.id);
        }

        failedDisableUserCommandV1(status) {
            alert(status.Error)
        }

        handleEnableUserCommandV1() {
            if (confirm(`Do you really want to restore user ${this.email}?`))
                this.invokeEnableUserCommandV1(this.id);
        }

        handleAcceptUserAccessRequestCommandV1() {
            if (confirm(`Do you really want to accept user access request for ${this.email}?`))
                this.invokeAcceptUserAccessRequestCommandV1(this.id);
        }

        handleRejectUserAccessRequestCommandV1() {
            if (confirm(`Do you really want to reject user access request for ${this.email}?`))
                this.invokeRejectUserAccessRequestCommandV1(this.id);
        }
    }
</script>
